module.exports = __webpack_public_path__ + "img/71.27d67c4c.jpg";